
/* injects from baggage-loader */

/*
 * Run after loading modules
 */

angular.module("siter.io").run([
  "$rootScope", "$state", "$timeout", "$stateParams", "$modal", "$window", "$location", "Restangular", "growl", "$locale", "$cookies", "$http", "TplCache", "Auth", "$templateCache", "Intercom",
  ($rootScope, $state, $timeout, $stateParams, $modal, $window, $location, Restangular, growl, $locale, $cookies, $http, TplCache, Auth, $templateCache, Intercom) => {

    $locale.id = 'ru-ru';

    Auth.check();
    Intercom.init();

    $rootScope.originHost = document.location.origin;
    $rootScope.logout = Auth.logout;
    $rootScope.$on("$stateChangeSuccess", () => {
      $rootScope.title = $state.current.title;
    });
    $rootScope.$on('$stateChangeStart', (event, next) => {
      Auth.isReadyLogged()["catch"](() => {
        if (next.auth) {
          return $location.path('/');
        }
      });
    });

    $rootScope.$on('current:user', () => {
      if ($state.current.name.indexOf('admin.dashboard') === 0 && $rootScope.currentUser.role === 'client') {
        $location.path('/404');
      }
    });

    const token = window.justclick.currentUser.authentication_token;

    Restangular.setDefaultHeaders({"X-AUTH-TOKEN": token});
    $cookies.put("auth_token", token);

    /**
     * Метод для загрузки всех шаблонов
     * @param requireContext
     * @returns {Array|*}
     */
    const requireAll = (requireContext) => {
      return requireContext.keys().map((val) => {
        return {tpl: requireContext(val), name: val};
      });
    };

    const jades = requireAll(
      require.context('html-loader!pug-html-loader!../', true, /\.jade$/)
    );

    jades.map((val) => {
      $templateCache.put(val.name, val.tpl);
    });
  }
]);



// WEBPACK FOOTER //
// ./src/app/app-main/siter.run.js